import { Modal } from "staysure-component-library";

import { TextButton } from "@/app/shared-components/cta-button/cta-buttons";
import { OptionListProps } from "@/types/LocationFromType";

import styleComponent from "./location-to-container.module.css";

type SameCountryModalProps = {
  isOpen: boolean;
  setIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
  modalHeaderText: string;
  modalSubText: string;
  agreeButtonText: string;
  closeButtonText: string;
  sameCountrySelected: OptionListProps[] | undefined;
  selectedSTCountry: OptionListProps[] | undefined;
  setSelectedSTCountry: React.Dispatch<
    React.SetStateAction<OptionListProps[] | undefined>
  >;
  tagSearchFieldOnChange: (value: OptionListProps[]) => void;
  setIsDisable: React.Dispatch<React.SetStateAction<boolean>>;
};

function SameCountryModal({
  isOpen,
  setIsOpen,
  modalHeaderText,
  modalSubText,
  agreeButtonText,
  closeButtonText,
  sameCountrySelected,
  selectedSTCountry,
  setSelectedSTCountry,
  tagSearchFieldOnChange,
  setIsDisable,
}: Readonly<SameCountryModalProps>) {
  const handleAgreeButtonClick = () => {
    setIsOpen(false);
    if (sameCountrySelected && sameCountrySelected?.length > 0) {
      const modifiedValue = selectedSTCountry
        ? [...selectedSTCountry, ...sameCountrySelected]
        : sameCountrySelected;
      setSelectedSTCountry(modifiedValue);
      tagSearchFieldOnChange(modifiedValue);
    }
    setIsDisable(true);
    setTimeout(() => setIsDisable(false), 100);
  };

  const handleCloseButtonClick = () => {
    setIsOpen(false);
    setIsDisable(true);
    setTimeout(() => setIsDisable(false), 100);
  };

  return (
    <Modal
      className={`${styleComponent.same_country_modal} md:p-spacing-xxxl p-spacing-l md:max-w-[416px] max-w-[327px] w-full`}
      isOpen={isOpen}
      onOpenChange={(newIsOpen) => setIsOpen(newIsOpen)}
      underlayStyles={{
        zIndex: 9999,
        background: "rgba(26, 26, 26, 0.6)",
      }}
      modalStyles={{
        display: "flex",
        background: "white",
        position: "fixed",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        borderRadius: 8,
      }}
    >
      <div data-testid="modal-data-test-id">
        <h1 className="text-text-title font-header-font md:text-3xl text-[23px] text-center md:leading-[34.1px] leading-[27.6px] md:mb-spacing-s mb-spacing-xs">
          {modalHeaderText}
        </h1>
        <div className={styleComponent.text_content}>{modalSubText}</div>
        <div className="flex md:flex-row flex-col">
          <TextButton
            data-testid="location-to-agree-button"
            hierarchy="primary"
            label={agreeButtonText}
            onClick={handleAgreeButtonClick}
            className="md:mr-2 md:mb-0 mb-2 !h-[48px] md:w-[148px] leading-[18px] w-full text-text-on-primary"
          />
          <TextButton
            data-testid="location-to-close-button"
            hierarchy="secondary"
            label={closeButtonText}
            onClick={handleCloseButtonClick}
            className="!h-[48px] md:w-[148px] leading-[18px] w-full"
          />
        </div>
      </div>
    </Modal>
  );
}

export default SameCountryModal;
